import Resources from '../../../../helpers/resources';
import modalActions from '../../../../containers/modal-container/modal-actions';
import dropdownDataActions from '../../redux/dropdown-data/dropdown-data-actions';
import { MATHLETICS_ID } from '../../../../helpers/constants';

export const ALL_CLASSES_RETRIEVED = 'ALL_CLASSES_RETRIEVED';

function getClassesData() {
    return (dispatch) =>
        Resources.allClassrooms
            .get()
            .withParams({ productId: MATHLETICS_ID })
            .send()
            .then((payload) => {
                if (payload.data && Array.isArray(payload.data)) {
                    const classes = mapClassesData(payload.data);
                    dispatch({
                        type: ALL_CLASSES_RETRIEVED,
                        payload: classes
                    });
                    dispatch(dropdownDataActions.setClassroomList(classes));
                } else {
                    dispatch(
                        modalActions.openModal({
                            content: 'Failed to load class list'
                        })
                    );
                }
            });
}

function mapClassesData(data) {
    return data.map((item) => ({
        id: item.id,
        name: item.name,
        isClassEmpty: item.isClassEmpty
    }));
}

export default {
    getClassesData
};



// WEBPACK FOOTER //
// ./components/report-filters/redux/class-list/class-list-actions.js